<template>
  <div class="payment-summary-wrapper">
    <div class="payment-summary-list">
      <div class="summary-title">
        {{ $t('plans.orderSummary') }}
      </div>

      <div v-if="paymentSummary.total > 0">
        <!-- БАЗОВАЯ СТОИМОСТЬ ТАРИФА -->
        <div
          v-if="paymentSummary.planBasePrice > 0"
          class="base-price-wrapper payment-summary-item"
        >
          <span class="payment-summary-item-title">{{ $t('plans.amountDescription.planBasePrice') }}</span>
          <div class="dotted"></div>
          <span class="payment-summary-item-value">
          {{
              parseFloat(paymentSummary.planBasePrice).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                maximumFractionDigits: 2,
                minimumFractionDigits: 2
              })
          }}
        </span>
        </div>

        <!-- СТОИМОСТЬ ДОП. ПОЛЬЗОВАТЕЛЕЙ -->
        <div
          v-if="
            paymentInfo.plan !== FREE_TARIFF_NAME &&
            paymentSummary.additionalUsersPrice > 0
          "
          class="payment-summary-item extra-users-price-wrapper"
        >
        <span class="payment-summary-item-title">
          <span v-html="$tc('plans.amountDescription.priceForAdditionalUsers') + ','"></span>
            &nbsp;{{ paymentInfo.additionalUsers }} {{ $t('plans.piece') }}
          </span>

          <div class="dotted"></div>

          <span class="payment-summary-item-value">
          {{
              parseFloat(paymentSummary.additionalUsersPrice).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                maximumFractionDigits: 2,
                minimumFractionDigits: 2
              })
            }}
        </span>
        </div>

        <!-- СТОИМОСТЬ ДОП. ПРОФИЛЕЙ -->
        <div
          v-if="paymentSummary.additionalProfilesPrice > 0"
          class="payment-summary-item extra-users-price-wrapper"
        >
          <span class="payment-summary-item-title">
            {{ $t('plans.amountDescription.priceForAdditionalProfiles') }},
            {{
              paymentInfo.plan === FREE_TARIFF_NAME ? paymentInfo.additionalProfiles : paymentInfo.profilesCount - 1000
            }} {{ $t('plans.piece') }}
          </span>
          <div class="dotted"></div>
          <span class="payment-summary-item-value">
            {{
                parseFloat(paymentSummary.additionalProfilesPrice).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2
                })
              }}
          </span>
        </div>

        <!-- СКИДКА -->
        <div
          v-if="paymentSummary.discount"
          class="payment-summary-item discount-wrapper"
        >
        <span class="payment-summary-item-title">
          {{ $t('plans.discount') + ` (${paymentSummary.discountPercentage}%)` }}
        </span>
          <div class="dotted"></div>
          <span class="payment-summary-item-value">
          {{
              parseFloat(paymentSummary.discount).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                maximumFractionDigits: 2,
                minimumFractionDigits: 2
              })
            }}
        </span>
        </div>

        <!-- КОМИССИЯ ПЛАТЕЖНОЙ СИСТЕМЫ -->
        <div
          v-if="paymentSummary.paymentFee > 0"
          class="payment-summary-item payment-system-fee-wrapper"
        >
          <span class="payment-summary-item-title">
            <span v-html="$tc('plans.amountDescription.paymentSystemFee') + ` ${paymentSummary.paymentFeePercentage}%`"></span>
          </span>
          <div class="dotted"></div>
          <span class="payment-summary-item-value">
            {{
                parseFloat(paymentSummary.paymentFee).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2
                })
              }}
          </span>
        </div>

        <!-- БАЛАНС ПОЛЬЗОВАТЕЛЯ -->
        <div
          v-if="(balance.balance > 0) && !renew"
          class="payment-summary-item"
        >
        <span class="payment-summary-item-title">
          {{ $t('plans.amountDescription.balance') }}
        </span>
          <div class="dotted"></div>
          <span class="payment-summary-item-value">
          -{{
              parseFloat(balance.balance).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
                maximumFractionDigits: 2,
                minimumFractionDigits: 2
              })
            }}
        </span>
        </div>

        <!-- НАЛОГ -->
        <div
          v-if="paymentSummary.countryFee > 0"
          class="payment-summary-item"
        >
          <span class="payment-summary-item-title">
            {{ $t('plans.estimatedTax') + ` (${paymentSummary.countryFeePercentage}%)` }}
          </span>
          <div class="dotted"></div>
          <span class="payment-summary-item-value">
            {{
                parseFloat(paymentSummary.countryFee).toLocaleString('en-US', {
                  style: 'currency',
                  currency: 'USD',
                  maximumFractionDigits: 2,
                  minimumFractionDigits: 2
                })
              }}
          </span>
        </div>
      </div>

      <!-- ИТОГО -->
      <div class="payment-estimate-wrapper payment-summary-item">
        <span class="payment-summary-item-title payment-estimate-title">
          {{ $t('plans.total') }}
        </span>
        <div class="dotted"></div>
        <span class="payment-summary-item-value payment-estimate-value">
          {{
            paymentSummary.total > 0 ? parseFloat(paymentSummary.total).toLocaleString('en-US', {
              style: 'currency',
              currency: 'USD',
              maximumFractionDigits: 2,
              minimumFractionDigits: 2
            }) : '$0.00'
          }}
        </span>
      </div>

      <!-- ПРОМОКОД -->
      <div v-if="paymentSummary.total > 0" class="payment-summary-promocode-wrapper">
        <div
          v-if="!promocodeSectionOpened"
          class="payment-summary-promocode-closed"
          @click="handleOpenPromocodeSection"
        >
          {{ $t('plans.havePromocode') }}
        </div>
        <div v-else>
          <div
            class="payment-summary-section"
          >
            <input
              ref="promocodeInput"
              v-model="promocodeText"
              :placeholder="$t('common.promocode')"
              class="promocode-input"
              :style="`border: 1px solid ${promocodeInputColor}`"
              spellcheck="false"
              :disabled="paymentInfo.disablePromocode"
            />

            <v-btn
              class="promocode-apply-button"
              color="primary"
              text
              :loading="promocodeLoading"
              :disabled="!promocodeText"
              @click="handlePromoApply(promocodeText)"
            >
              {{ $t('common.apply') }}
            </v-btn>
          </div>

          <div
            v-if="promocodeState.status === 'error' && promocodeState.errorText"
            class="payment-summary-promocode-error-wrapper"
          >
            <img
              :src="alertIcon"
              alt="Alert"
              class="promocode-error-alert-icon"
            />

            <span class="promocode-error-alert-text">
              {{ $t('plans.errors.'+ promocodeState.errorText) }}
            </span>
          </div>
        </div>
      </div>

      <payment-access-control-alert v-if="roleIsUser" />

      <!-- ОПЛАТИТЬ -->
      <v-btn
        v-if="!upgrading && !switchPlan"
        color="primary"
        width="240"
        height="36"
        class="summary-pay-button"
        :disabled="!paymentSummary.total || roleIsUser"
        :loading="payLoading || paymentSummaryUpdating"
        @click="payIfValid"
      >
        {{ $t('common.pay') }}
      </v-btn>

      <!-- ОБНОВИТЬ -->
      <v-btn
        v-if="upgrading"
        color="primary"
        width="240"
        height="36"
        class="summary-pay-button"
        :disabled="roleIsUser"
        :loading="payLoading || paymentSummaryUpdating"
        @click="payIfValid"
      >
        {{ $t('common.upgrade') }}
      </v-btn>

      <payment-change-tariff-dialog
        v-if="dialogs.changeTariff"
        :pay="pay"
      />
      <payment-restriction-dialog v-if="dialogs.changeTariffRestriction" />
      <confirm-custom-plan-change-dialog
        v-if="dialogs.confirmCustomPlanChange"
        @payIfValid="payIfValid"
      />
      <!-- ОПЛАТИТЬ СЕЙЧАС - ПЕРЕХОД ТАРИФА -->
      <v-btn
        v-if="switchPlan"
        color="primary"
        width="240"
        height="36"
        class="summary-pay-button"
        :loading="payLoading || paymentSummaryUpdating"
        :disabled="roleIsUser"
        @click="handlePay"
      >
        {{ paymentSummary.total > 0 ? $t('common.payNow') : $t('common.upgrade') }}
      </v-btn>

      <!-- ВАРНИНГИ АВТОМАТИЧЕСКОГО ПРОДЛЕНИЯ ПРИ ОПЛАТЕ КАРТОЙ -->
      <div
        v-if="paymentInfo.paymentMethod === PAYMENT_METHOD_CARD_NAME"
        class="payment-summary-warning-wrapper"
      >
        <div class="payment-summary-warning-title">
          {{ $t('plans.yourSubscriptionWillAutomaticallyRenew') }} {{ subscriptionRenewDate }}
        </div>
        <div class="payment-summary-warning-desc">
          {{ $t('plans.youCanCancelAnyTimeBeforeThisDate') }}
        </div>
      </div>
    </div>

    <!-- ИНФА ПРО ОРГАНИЗАЦИЮ -->
    <div class="payment-summary-info-wrapper">
      <v-icon
        :size="15"
        class="payment-summary-info-icon"
        color="#A9ABB6"
      >
        mdi-map-marker-outline
      </v-icon>

      <company-address />
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import moment from "moment";
  import {
    BASE_TARIFF_NAME,
    FREE_TARIFF_NAME,
    TEAM_TARIFF_NAME,
    ENTERPRISE_TARIFF_NAME,
    PAYMENT_METHOD_CARD_NAME
  } from '@/constants/plans'
  import paymentMixin from "@/mixins/payment";
  import alertIcon from "@/assets/alertIcon.svg";
  import CompanyAddress from "../CompanyAddress";
  import PaymentChangeTariffDialog from '@/components/plans/dialogs/components/PaymentChangeTariffDialog.vue';
  import PaymentRestrictionDialog from '@/components/plans/dialogs/components/PaymentRestrictionDialog.vue';
  import PaymentAccessControlAlert from '@/components/plans/PaymentAccessControlAlert.vue'
  import ConfirmCustomPlanChangeDialog from '@/components/dialogs/ConfirmCustomPlanChangeDialog.vue'

  export default {
    name: 'PaymentDialogSummary',

    components: {
      ConfirmCustomPlanChangeDialog,
      PaymentAccessControlAlert,
      CompanyAddress,
      PaymentChangeTariffDialog,
      PaymentRestrictionDialog
    },

    mixins: [
      paymentMixin,
      CompanyAddress
    ],

    props: {
      estimate: {
        type: Number,
        required: true,
        default: 0
      },
      pay: {
        type: Function,
        required: true
      },
      handlePromoApply: {
        type: Function,
        required: true
      },
      payLoading: {
        type: Boolean,
        required: true,
        default: false
      },
      promocodeLoading: {
        type: Boolean,
        required: true,
        default: false
      },
      upgrading: {
        type: Boolean,
        default: false
      },
      renew: {
        type: Boolean,
        default: false
      },
      switchPlan: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        BASE_TARIFF_NAME,
        FREE_TARIFF_NAME,
        TEAM_TARIFF_NAME,
        ENTERPRISE_TARIFF_NAME,
        PAYMENT_METHOD_CARD_NAME,
        alertIcon,
        discountPercent: 0,
        promocodeSectionOpened: false,
        promocodeText: ''
      }
    },

    computed: {
      ...mapGetters({
        paymentInfo: 'plans/paymentInfo',
        statePromocode: 'plans/promocode',
        profile: 'main/profile',
        promocodeState: 'plans/promocodeState',
        paymentSummary: 'plans/paymentSummary',
        companyInfo: 'plans/companyInfo',
        paymentSummaryUpdating: 'plans/paymentSummaryUpdating',
        balance: 'plans/balance',
        dialogs: 'plans/dialogs'
      }),

      promocodeInputColor () {
        switch (this.promocodeState.status) {
          case 'success':
            return '#4CAF50'
          case 'error':
            return '#DB371F'
          default:
            return '#939393'
        }
      },

      subscriptionRenewDate() {
        let prolongDays = this.paymentInfo.prolongMonths * 30

        if (this.upgrading || this.switchPlan) {
          return moment()
            .add(prolongDays, 'days')
            .locale(this.$i18n.locale)
            .format('Do MMM YYYY')
        }

        return moment(this.profile.subscription.expiration)
          .add(prolongDays, 'days')
          .locale(this.$i18n.locale)
          .format('Do MMM YYYY')
      },

      roleIsUser () {
        return this.profile.role === 'user'
      }
    },

    watch: {
      paymentInfo: {
        deep: true,

        handler () {
          this.updatePaymentInfo(this.renew)
        }
      },

      'companyInfo.countryCode': {
        handler () {
          this.updatePaymentInfo(this.renew)
        }
      },

      promocodeSectionOpened: {
        handler (val) {
          if (val) {
            this.$nextTick(function () {
              this.$refs.promocodeInput.focus()
            })
          }
        }
      }
    },

    async created () {
      await this.$store.dispatch('plans/clearPromo')

      if (this.paymentInfo.promocode) {
        this.promocodeSectionOpened = true
        this.promocodeText = this.paymentInfo.promocode

        this.handlePromoApply(this.paymentInfo.promocode)
      }
    },

    methods: {
      handleOpenPromocodeSection () {
        this.promocodeSectionOpened = true
      },
      handlePay () {
        if (this.profile.subscription?.isCustomTariff) {
          this.$store.dispatch('plans/openDialog', 'confirmCustomPlanChange')

          return
        }

        this.payIfValid()
      },
      payIfValid () {
        if (this.paymentSummary?.total < 23 && this.paymentInfo.coin === 'ETH') return

        if(this.paymentSummary.total > 0) {
          this.pay();
          return
        }

        if (this.balance.new.countPlanUnpaidChanges >= 3) {
          this.$store.dispatch('plans/openDialog', 'changeTariffRestriction')
        } else {
          this.$store.dispatch('plans/openDialog', 'changeTariff')
        }
      }
    }
  }
</script>

<style>
  .payment-summary-wrapper {
    background: #F6F7FB;
    border-left: 1px solid #EBECF0;
    min-width: 280px;
    width: 280px;
    padding: 20px;
    border-bottom-left-radius: unset!important;
    border-bottom-right-radius: 20px;
    border-top-right-radius: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .dotted {
    width: 100%;
    opacity: 0.5;
    border-bottom: 1px dotted #555E71;
    flex: 1;
    margin: 0 3px;
  }

  .summary-title {
    font-weight: 500;
    font-size: 18px;
    line-height: 120%;
    color: #000000;
    margin-bottom: 24px;
  }

  .payment-summary-item {
    display: flex;
    align-items: baseline;
    margin-bottom: 12px;
  }

  .payment-summary-item-title {
    font-weight: 400;
    font-size: 11px;
    line-height: 13px;
    display: flex;
    align-items: flex-end;
    font-feature-settings: 'tnum' on, 'lnum' on;
    color: #555E71;
  }

  .payment-summary-item-value {
    font-weight: 400;
    font-size: 11px;
    line-height: 13px;
    display: flex;
    align-items: flex-end;
    font-feature-settings: 'tnum' on, 'lnum' on;
    color: #555E71;
  }

  .payment-estimate-title {
    font-weight: 700;
    color: #000000;
  }

  .payment-estimate-value {
    font-weight: 700;
    color: #000000;
  }

  .payment-summary-promocode-wrapper {
    margin-top: 24px;
  }

  .payment-summary-promocode-closed {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #B547E9;
    text-decoration: underline dashed;
    cursor: pointer;
  }

  .payment-summary-section {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .promocode-input {
    padding: 6px 12px 6px 16px;
    width: 124px;
    height: 40px;
    border: 1px solid #939393;
    border-radius: 50px;
    font-weight: 400;
    font-size: 14px;
    line-height: 120%;
    color: #000000;
    outline: unset;
  }

  .promocode-apply-button {
    width: 108px;
    height: 40px;
    border: 1px solid #B547E9;
    border-radius: 50px;
    padding: 12px;
  }

  .promocode-apply-button .v-btn__content {
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 1.25px;
    text-transform: uppercase;
    color: #B547E9;
  }

  .promocode-error-alert-text {
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: #DB371F;
  }

  .payment-summary-promocode-error-wrapper {
    display: flex;
    align-items: flex-start;
    margin-top: 5px;
  }

  .promocode-error-alert-icon {
    margin-right: 7px;
  }

  .summary-pay-button {
    margin-top: 24px;
    box-shadow: 0 0 0 rgba(0, 0, 0, 0.12), 0 0 0 rgba(0, 0, 0, 0.14), 0 0 0 rgba(0, 0, 0, 0.2);
    border-radius: 50px;
  }

  .payment-summary-warning-wrapper {
    margin-top: 24px;
  }

  .payment-summary-warning-title {
    font-weight: 600;
    font-size: 12px;
    line-height: 130%;
    color: #2E2832;
  }

  .payment-summary-warning-desc {
    font-weight: 400;
    font-size: 12px;
    line-height: 135%;
    color: #555E71;
    margin-top: 6px;
  }

  .payment-summary-info-wrapper {
    font-weight: 400;
    font-size: 12px;
    line-height: 130%;
    color: #A9ABB6;
    display: flex;
    align-items: flex-start;
  }

  .payment-summary-info-icon {
    margin-right: 8px;
  }
</style>
